var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLgChevronLeft = function SvgLgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "lg-chevron-left_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "lg-chevron-left_svg__lg-chevron-left"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.62 2.99a1.25 1.25 0 0 0-1.77 0L6.54 11.3a.996.996 0 0 0 0 1.41l8.31 8.31c.49.49 1.28.49 1.77 0s.49-1.28 0-1.77L9.38 12l7.25-7.25c.48-.48.48-1.28-.01-1.76",
    className: "lg-chevron-left_svg__vector"
  }))));
};
export { SvgLgChevronLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5MZyBDaGV2cm9uIExlZnQ8L3RpdGxlPjxnIGNsYXNzPSJsZy1jaGV2cm9uLWxlZnQiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE2LjYyIDIuOTlhMS4yNSAxLjI1IDAgMCAwLTEuNzcgMEw2LjU0IDExLjNhLjk5Ni45OTYgMCAwIDAgMCAxLjQxbDguMzEgOC4zMWMuNDkuNDkgMS4yOC40OSAxLjc3IDBzLjQ5LTEuMjggMC0xLjc3TDkuMzggMTJsNy4yNS03LjI1Yy40OC0uNDguNDgtMS4yOC0uMDEtMS43NloiIGNsYXNzPSJ2ZWN0b3IiLz48L2c+PC9zdmc+";